<ng-container *transloco="let t; prefix: scope">
  <rma-navigation-header [showBackLink]="false" />
  <mat-card class="mx-auto h-full w-full max-w-3xl px-4 py-6 md:mb-4 md:mt-14 md:h-auto md:p-10">
    <form [formGroup]="unSubForm">
      <h1 class="text-heading-2">{{ t('title') }}</h1>
      @if (reasons$ | async; as reasons) {
        <mat-radio-group class="mb-6 mt-6 flex flex-col" formControlName="cancellationReason">
          @for (reason of reasons; track reason) {
            <mat-radio-button [value]="reason" color="primary">{{ t('reasons.' + (reason | lowercase)) }} </mat-radio-button>
            @if (reason === 'AnotherReviewPlatform' && (displayCompetitors$ | async)) {
              <div class="ml-3 flex flex-wrap">
                @if (competitors$ | async; as competitors) {
                  <mat-form-field class="my-2 ml-5" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ t('competitors.selectone') }}</mat-label>
                    <mat-select [placeholder]="t('competitors.selectone')" formControlName="cancellationCompetitor">
                      @for (competitor of competitors; track competitor) {
                        <mat-option [value]="competitor">
                          {{ t('competitors.' + (competitor | lowercase)) }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
                @if (displayOtherTool$ | async) {
                  <mat-form-field class="my-2 ml-5" appearance="outline" subscriptSizing="dynamic">
                    <input [placeholder]="t('competitors.specify')" matInput formControlName="otherTool" />
                  </mat-form-field>
                }
              </div>
            }
          }
        </mat-radio-group>
      }

      @if (displayOtherReason$ | async) {
        <mat-form-field class="w-full" appearance="outline">
          <mat-label>{{ t('feedback') }}</mat-label>
          <textarea matInput formControlName="cancellationFeedback"></textarea>
        </mat-form-field>
      }

      <div
        class="fixed inset-x-0 bottom-0 flex items-center justify-between border-t border-t-steel-20 bg-white p-4 md:relative md:p-0 md:pt-4"
      >
        <button type="button" routerLink="/manage-account/billing" mat-button color="primary">{{ t('cancel') }}</button>
        <button type="button" [disabled]="unSubForm.invalid" (click)="onSubmit()" mat-flat-button color="primary">
          <span>{{ t('submit') }}</span>
        </button>
      </div>
    </form>
  </mat-card>
</ng-container>
